import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ContainerAttachmentsService } from '../../containers/attachments/container-attachments.service';
import { File } from '../../shared/models/file.model';

@Component({
  host: { 'test-id': 'file-version-badge' },
  selector: 'file-version-badge',
  styles: [`
    :host {
      display: inline-flex;
    }
  `],
  template: `
    <a [matTooltip]="'fileVersionBadge.tooltip' | translate"
      (click)="versionHistory(file)" class="badge-icon">{{ file.version }}</a>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileVersionBadgeComponent {
  @Input() file: File

  @Output() afterChange = new EventEmitter<File>()

  constructor(
    private attachments: ContainerAttachmentsService,
  ) {}

  versionHistory(file: File): void {
    this.attachments.versionHistory(file).then(modified => {
      if (modified) {
        this.afterChange.emit(this.file);
      }
    });
  }
}
